module.exports = __webpack_public_path__ + "img/kiosk-clamp.b9965953.svg";